// 评论（biz_comment）应用层领域逻辑：server 与 website 共享的纯函数，零 IO 依赖。

export type CommentContent = Array<
  { type: 'text'; value: string } | { type: 'mention'; value: string; name: string } // value 为用户 ID，name 为显示名称
>

// 评论附件（biz_comment.attachments 元素）：仅记录对象存储落点，不另建 biz_file 行。
//   storageId  = biz_storage.id（附件所在 COS 桶配置行）
//   storageKey = 对象 key（相对 storage.prefix，以 / 开头；由 buildOssCommentAttachmentPath 生成）
// 展示时由服务端按 storageId 取行 + storageKey 构造 CDN URL。
export interface CommentAttachment {
  storageId: string
  storageKey: string
}

// 从 biz_comment.content 提取纯文本；text 段直拼，mention 段输出 @{name}。兜底空串，绝不抛错。
export const extractCommentText = (content: unknown): string => {
  if (!Array.isArray(content)) {
    return ''
  }
  return content
    .map(item => {
      if (!item || typeof item !== 'object') return ''
      const { type, value, name } = item as Record<string, unknown>
      if (typeof value !== 'string') return ''
      if (type === 'text') return value
      if (type === 'mention') return `@${typeof name === 'string' ? name : value}`
      return ''
    })
    .join('')
}
